import axios from "axios";

export enum AddOnType {
  WALLET_PASS = "WALLET_PASS",
  EMAIL = "EMAIL",
  COMMUNITY_APP = "COMMUNITY_APP",
  EMAIL_OVERAGE = "EMAIL_OVERAGE",
}

export interface AddonDTO {
  id: string;
  displayName: string;
  type: AddOnType;
  priceMonthly: number;
  priceAnnual: number | null;
}

export async function getAddons() {
  const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

  return await axios.get<AddonDTO[]>(`${baseApiUrl}/payment/v0/addons`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
